import getContentDataSource from '@gameday/core/datasources/helpers/getContentDatasource';

const videoCarouselDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const {
            gumbo: {
                gamePk
            },
            config: {
                env,
                locale = 'en-US',
                language = 'en',
                useContentApi = false,
                context: {
                    gameContext = 'mlb'
                } = {}
            }
        } = state;

        const {
            name: contentDataSource,
            params: contentParams
        } = getContentDataSource(useContentApi, { gamePk, locale, gameContext, env });

        return Promise.allSettled([
            componentDataEngine.fetch('schedule', { gamePk, language }),
            componentDataEngine.fetch(contentDataSource, contentParams)
        ]).then(([scheduleRes, contentRes]) => {
            componentDataEngine.store(scheduleRes.value);
            componentDataEngine.store(contentRes.value);
        });
    };
};

export default videoCarouselDataRequestAction;
